/** Regroupement d'affichage des fonctionnalités : aucune offre ne connaît ces thèmes. */
export const FUNCTIONALITY_THEMES: { references: Account_FunctionalityReference[]; title: string }[] = [
	{
		title: 'Volumétrie',
		references: [
			'project_limit',
			'user_limit',
			'map_limit',
			'place_limit',
			'place_field_limit',
			'nb_images',
			'iframe_limit',
		],
	},
	{
		title: 'Création de cartes',
		references: [
			'geolocalisation',
			'map_nesting',
			'place_import',
			'place_path',
			'use_mediatech',
			'create_tpl_project',
		],
	},
	{
		title: 'Apparence et accès',
		references: [
			'auth_map',
			'custom_sub_domain',
			'custom_logo',
			'custom_css',
		],
	},
	{
		title: 'Analyse',
		references: [
			'basic_statistic',
			'advanced_statistic',
		],
	},
	{
		title: 'Gestion',
		references: [
			'archive_project',
			'support_enabled',
		],
	},
];

export const OTHER_FUNCTIONALITIES_TITLE = 'Autres fonctionnalités';

/** Range des entrées par thème ; ce qu'aucun thème ne cite ferme la marche. */
export const groupByTheme = <T extends { reference: string }>(entries: T[]) => {
	const remaining = new Map(entries.map(entry => [entry.reference as string, entry]));

	const groups = FUNCTIONALITY_THEMES.map(theme => ({
		entries: theme.references.reduce<T[]>((acc, reference) => {
			const entry = remaining.get(reference);

			if (entry) remaining.delete(reference);

			return entry ? [...acc, entry] : acc;
		}, []),
		title: theme.title,
	})).filter(group => group.entries.length);

	return remaining.size
		? [...groups, { entries: [...remaining.values()], title: OTHER_FUNCTIONALITIES_TITLE }]
		: groups;
};
